import { render, staticRenderFns } from "./AreaAlarms.vue?vue&type=template&id=36758225&scoped=true"
import script from "./AreaAlarms.vue?vue&type=script&lang=ts"
export * from "./AreaAlarms.vue?vue&type=script&lang=ts"
import style0 from "./AreaAlarms.vue?vue&type=style&index=0&id=36758225&prod&scoped=true&lang=scss"
import style1 from "./AreaAlarms.vue?vue&type=style&index=1&id=36758225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36758225",
  null
  
)

export default component.exports